<template>
  <div class="box no-border" @click.prevent="redirect">
    <template v-if="!hasConnectedService">
      <img
        src="/img/icons/notifications-alert.svg"
        class="notification-alert"
      />
      <div class="text">
        <span class="f-w-bold fs-16">
          {{ title }}
        </span>
        <span class="fs-14">
          {{ text }}
        </span>
      </div>
      <div class="images">
        <img
          v-for="service in services"
          :key="service.service"
          :src="getIcon(service.service)"
        />
      </div>
    </template>
    <template v-else>
      <img
        src="/img/icons/notifications-connected.svg"
        class="notification-alert"
      />
      <div class="text">
        <span class="f-w-bold fs-16">
          Вы получаете уведомления
        </span>
        <span class="fs-14">
          Вы подключили сервис(-ы), для уведомлений, чтобы настроить их или
          подключить еще
          <a :href="link">нажмите на эту ссылку</a>
        </span>
      </div>
      <div class="images">
        <template v-for="service in services">
          <img
            v-if="service.state != null && service.state != 'undefined'"
            :key="service.service"
            :src="getIcon(service.service)"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import store from "../../store/store";
import i18nCustom from "../../plugins/i18nCustom"
import Vue from 'vue'

import { mapActions, mapGetters } from "vuex";

Vue.use(i18nCustom)

export default {
  name: "NotificationsStatus",
  store,
  components: {},
  data() {
    return {
      title: null,
      text: null,
      link: null,
    };
  },
  async created() {
    this.title = this.$parent.$options.customElement.attributes[
      "data-title"
    ].value;
    this.text = this.$parent.$options.customElement.attributes[
      "data-text"
    ].value;
    this.link = this.$parent.$options.customElement.attributes[
      "data-link"
    ].value;

    await this.GET_SERVICES();
    await this.GET_USER_SERVICES();
  },
  mounted() {
    document.addEventListener("login", (e) => {
      window.location.reload();
    });
  },
  computed: {
    ...mapGetters({
      services: "notify/getServicesAndUserServices",
      user: "users/getUser",
    }),
    hasConnectedService() {
      if (!this.services) return false;

      const connectedService = this.services.find((service) => {
        return (
          service.state &&
          service.state.is_active == 1 &&
          service.service != "EmailNotifier"
        );
      });

      return connectedService != undefined;
    },
  },
  methods: {
    ...mapActions({
      GET_SERVICES: "notify/GET_SERVICES",
      GET_USER_SERVICES: "notify/GET_USER_SERVICES",
      GET_ME: "users/GET_ME",
    }),
    getIcon(service) {
      if (service == "EmailNotifier") {
        return "/img/icons/notification-email.svg";
      } else if (service == "TelegramNotifier") {
        return "/img/icons/notification-telegram.svg";
      } else if (service == "DiscordNotifier") {
        return "/img/icons/notification-discord.svg";
      } else if (service == "VkNotifier") {
        return "/img/icons/notification-vk.svg";
      }

      return null;
    },
    redirect() {
      if (!this.user) {
        return document.dispatchEvent(new CustomEvent("RequestAuth"));
      }

      window.location.href = this.link;
    },
  },
};
</script>

<style src="bootstrap/dist/css/bootstrap.min.css"></style>
<style src="../../../../web/css/style.css"></style>
<style lang="scss" scoped>
.box {
  border: 0;
  flex-direction: row;
  align-items: center;
  display: flex;
  background: #fff;
  gap: 18px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  &:hover {
    cursor: pointer;
    background: #f8f9fa;
  }
  .notification-alert {
    display: flex;
  }
  .text {
    display: flex;
    flex-direction: column;
  }
  .images {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 16px;
    img {
      height: 32px;
    }
  }
}
</style>
